import { Action } from 'redux-actions';
import { StudioState, TableLayout } from '../../types/store';
import { EMPTY_SELECTION_STATE } from '../../../constants';
import { RefreshTableSuccessPayload, updateSelection, setTableLayout } from '../../actions/studio';

export const handleRefreshTableSuccess = (
  state: StudioState,
  action: Action<RefreshTableSuccessPayload>
): StudioState => {
  const {
    freeCapacity,
    maxCapacity,
    resultsTotalCount,
    tags,
    originalsData,
    selectedFolder,
    preserveSelection,
    appData,
  } = action.payload;
  return {
    ...state,
    freeCapacity: freeCapacity,
    maxCapacity: maxCapacity,
    duperbrowseStreamVersion: state.duperbrowseStreamVersion + 1,
    resultsTotalCount,
    tags,
    originalsData,
    selectedFolder,
    apps: {
      ...state.apps,
      appData,
    },
    ...(!preserveSelection && { selection: EMPTY_SELECTION_STATE }),
  };
};

export const handleUpdateSelection = (
  state: StudioState,
  { payload }: ReturnType<typeof updateSelection>
): StudioState => {
  const hasSelection = payload.selection.selectedRows.length > 0;
  return {
    ...state,
    selection: payload.selection,
    // when all items are unselected, we clear the batch action state
    batchAction: hasSelection ? state.batchAction : undefined,
  };
};

export const handleSelectBatchAction = (state: StudioState, action): StudioState => ({
  ...state,
  batchAction: action.payload.batchAction,
});

export const handleCancelBatchAction = (state: StudioState): StudioState => ({
  ...state,
  batchAction: undefined,
});

export const handleSetNewModalLoading = (state: StudioState, action): StudioState => ({
  ...state,
  newModalLoading: action.payload.loading,
});

export const handleSetTableLayout = (
  state: StudioState,
  action: ReturnType<typeof setTableLayout>
): StudioState => ({
  ...state,
  table: {
    ...state.table,
    layout: action.payload.layout === 'list' ? TableLayout.LIST : TableLayout.GRID,
  },
});
